import React from "react";
import AuthPage from ".";
import ProtectedRouteAuth from "../../hooks/ProtectedRouteAuth";

const useAuthRoutes = () => {
  const routers = React.useMemo(
    () => [
      {
     
        path: "/",
        element: 
        <ProtectedRouteAuth 
        outlet={
        <AuthPage />
        }
        />
      },
      {
        path: "/auth",
        element:
        <ProtectedRouteAuth 
        outlet={
           <AuthPage />
          }
          />
      },
    ],
    []
  );

  return routers;
};

export default useAuthRoutes;
